//export const API_URL="http://localhost:5000/api/v1"
// export const API_URL = "/api/v1"
export const API_URL = process.env.REACT_APP_API_URL